import { routes } from '~/helpers/routes';

export const redirectToRuleLibrary = (nextUrl: string) => {
  window.location.assign(routes.admin.customers.ruleLibrarySessionWithNext(nextUrl));
};
